export default "__VITE_ASSET__DjzjXtvn__"